import * as React from 'react';
import { Box, Typography } from '@mui/material';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { PageLayout } from '../components/layout';
import { AiSearchModule } from '../components/search/AiSearchModule';

export const AiSearchPage: React.FC = () => {
  return (
    <PageLayout
      header={
        <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TravelExploreIcon color="primary" />
          Ricerca dati (AI)
        </Typography>
      }
    >
      <Box sx={{ padding: '1rem' }}>
        <AiSearchModule variant="page" />
      </Box>
    </PageLayout>
  );
};
